import { useCallback, useState } from 'react';

import { resizeSignature } from './tools';

export const useSignature = () => {
    const [signature, setSignature] = useState();
    const [signatureEmpty, setSignatureEmpty] = useState(!signature || signature.isEmpty());

    const handleSetSignature = useCallback((data) => {
        resizeSignature(data);
        setSignature(data);
    }, []);

    const handleUpdateActions = useCallback(() => setSignatureEmpty(!signature || signature.isEmpty()), [signature]);

    const handleClearSignature = useCallback(() => {
        if (signature) {
            signature.clear();
        }
    }, [signature]);

    return {
        signature,
        signatureEmpty,
        handleSetSignature,
        handleUpdateActions,
        handleClearSignature,
    };
};
